/* eslint-disable no-underscore-dangle, no-undef, max-len, no-unused-vars, prefer-template */
import $ from 'jquery';
import insightsClient from 'search-insights';
import algoliasearch from 'algoliasearch/lite';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';

function getIconByType(type) {
    const iconNames = {
        video: 'play_circle',
        serie: 'video_library',
        podcast: 'podcasts',
        booklet: 'menu_book',
        magazine: 'menu_book',
        game: 'games',
        theme: 'folder_special',
        educational_tool: 'description',
    };
    return iconNames[type];
}

function createAriaRegion(id = '') {
    const ariaRegion = document.createElement('div');
    if (id) {
        ariaRegion.id = id;
    }
    ariaRegion.setAttribute('aria-live', 'polite');
    ariaRegion.setAttribute('aria-atomic', 'true');
    ariaRegion.setAttribute('role', 'status');
    ariaRegion.classList.add('visually-hidden');
    document.body.appendChild(ariaRegion);
    return ariaRegion;
}

const translations = {
    en: {
        placeholder: 'What subject would you like to talk about?',
        results: 'results',
        selected: 'selected',
        noResults: 'No results.',
    },
    fr: {
        placeholder: 'Quel sujet souhaitez-vous aborder?',
        results: 'résultats',
        selected: 'sélectionné',
        noResults: 'Aucun résultat.',
    },
};
const searchForm = document.querySelector('.js-autocomplete-searchform');

if (searchForm) {
    const $headerSearch = $('.header-search-form');
    const $headerSearchToggle = $('.header-search-toggle');
    const searchClient = algoliasearch(drupalSettings.algolia_search.app_id, drupalSettings.algolia_search.algolia_key);
    const siteLanguage = document.querySelector('html').getAttribute('lang');
    const indexName = drupalSettings.algolia_search.index_name;
    const searchResultsUrl = drupalSettings.algolia_search.search_path;
    const schoolLevelsEl = 'input[name="school_levels"]:checked';
    const schoolSubjectsEl = 'input[name="school_subjects"]:checked';
    const isStudent = drupalSettings.algolia_search.is_student;

    const ariaRegion = createAriaRegion('search-form-aria-region');

    insightsClient('init', {
        appId: drupalSettings.algolia_search.app_id,
        apiKey: drupalSettings.algolia_search.algolia_key,
        useCookie: true,
    });

    let searchQuery = '';
    autocomplete({
        container: searchForm.querySelector('.autocomplete'),
        detachedMediaQuery: 'none',
        insights: true,
        placeholder: translations[siteLanguage].placeholder,
        getSources({ query, setContext }) {
            let defaultFilters = `lang:"${siteLanguage}"`;
            if (isStudent) {
                defaultFilters = `lang:"${siteLanguage}" AND NOT content_type:thematic_folder`;
            }

            // get label value of checkbox
            const schoolLevelsId = $(schoolLevelsEl).attr('id');
            const schoolSubjectsId = $(schoolSubjectsEl).attr('id');

            const schoolLevelsLabel = $(`label[for="${schoolLevelsId}"]`).find('.facet-list-item-label-text').text();
            const schoolSubjectsLabel = $(`label[for="${schoolSubjectsId}"]`).find('.facet-list-item-label-text').text();

            const facetFilters = [];
            if (schoolLevelsLabel) {
                facetFilters.push(`school_levels:${schoolLevelsLabel}`);
            }

            if (schoolSubjectsLabel) {
                facetFilters.push(`school_subjects:${schoolSubjectsLabel}`);
            }
            return [
                {
                    sourceId: 'products',
                    getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName,
                                    query,
                                    params: {
                                        filters: defaultFilters,
                                        facetFilters,
                                    },
                                },
                            ],
                            transformResponse({ results, hits }) {
                                setContext({
                                    nbProducts: results[0].nbHits,
                                });
                                return hits;
                            },
                        });
                    },
                    templates: {
                        header({ state }) {
                            ariaRegion.textContent = `${state.context.nbProducts} ${translations[siteLanguage].results}`;
                            return `${state.context.nbProducts} ${translations[siteLanguage].results}`;
                        },
                        item({ item, html }) {
                            return html`
                                        <a class="aa-ItemLink" href="${item.url}">
                                            <span class="item-icon">
                                                <span class="material-symbols-rounded">${getIconByType(item.type)}</span>
                                            </span>
                                            <span class="item-title">${item.title}</span>
                                            <span class="item-type">${item.type}</span>
                                        </a>
                                    `;
                        },
                        noResults() {
                            return `${translations[siteLanguage].noResults}`;
                        },
                    },
                },
            ];
        },
        onStateChange({ state }) {
            searchQuery = state.query;
        },
    });

    const redirectToSearch = () => {
        // Only one choice by group checkbox is supported
        const schoolLevels = $(schoolLevelsEl).val() ? '&' + $(schoolLevelsEl).val() : '';
        const schoolSubjects = $(schoolSubjectsEl).val() ? '&' + $(schoolSubjectsEl).val() : '';

        const query = searchQuery ? `query=${searchQuery}` : '';
        const endUrl = `${searchResultsUrl}/?${query}${schoolLevels}${schoolSubjects}#js-results-count`;

        window.location = endUrl; // Redirection page de recherche
    };

    $('#autocomplete-0-input').on('keydown', (ev) => { // On enter key press
        if (ev.key === 'Enter') {
            ev.preventDefault();
            redirectToSearch();
        }
    });
    $(searchForm.querySelector('.submit-search')).on('click', (ev) => {
        ev.preventDefault();
        redirectToSearch();
    });
    $('body').on('click', '.facet-selector-toggle', (ev) => {
        ev.preventDefault();
        const $facetSelectorToggle = $(ev.currentTarget);
        const $facetSelector = $facetSelectorToggle.closest('.facet-selector');
        const $otherFacetSelectors = $('.facet-selector.is-active').not($facetSelector);
        if ($facetSelector.hasClass('is-active')) {
            $facetSelector.removeClass('is-active');
            $facetSelectorToggle.attr('aria-expanded', 'false');
        } else {
            $otherFacetSelectors.removeClass('is-active');
            $('.facet-selector-toggle', $otherFacetSelectors).attr('aria-expanded', 'false');
            $facetSelector.addClass('is-active');
            $facetSelectorToggle.attr('aria-expanded', 'true');
        }
    });
    $(document).on('click', (ev) => {
        const $facetSelector = $('.facet-selector');
        if ($facetSelector.hasClass('is-active') && !$(ev.target).closest('.facet-selector').length) {
            $facetSelector.removeClass('is-active');
            $('.facet-selector-toggle', $facetSelector).attr('aria-expanded', 'false');
        }
        if ($headerSearch.hasClass('is-active')
            && !$(ev.target).closest('.header-search-form').length
            && !$(ev.target).closest('.header-search-toggle').length) {
            $headerSearch.removeClass('is-active');
            $headerSearchToggle.attr('aria-expanded', 'false');
        }
    });
    $(document).on('focusin', (ev) => {
        if (!$(ev.target).closest('.levels-selector').length) {
            $('.levels-selector').removeClass('is-active');
            $('.levels-selector').find('.facet-selector-toggle').attr('aria-expanded', 'false');
        }
        if (!$(ev.target).closest('.topics-selector').length) {
            $('.topics-selector').removeClass('is-active');
            $('.topics-selector').find('.facet-selector-toggle').attr('aria-expanded', 'false');
        }
        if (!$(ev.target).closest('.header-search-form').length
            && !$(ev.target).closest('.header-search-toggle').length) {
            $('.header-search-form').removeClass('is-active');
            $headerSearchToggle.attr('aria-expanded', 'false');
        }
    });
    $(document).on('keydown', (ev) => {
        const $facetSelector = $('.facet-selector');
        if ($facetSelector.hasClass('is-active')) {
            if (ev.key === 'Escape') {
                $facetSelector.removeClass('is-active');
                $('.facet-selector-toggle', $facetSelector).attr('aria-expanded', 'false');
            }
        } else if ($headerSearch.hasClass('is-active')) {
            if (ev.key === 'Escape') {
                $headerSearch.removeClass('is-active');
                $headerSearchToggle.attr('aria-expanded', 'false');
            }
        }
    });

    $('body').on('click', 'input[type=checkbox].facet-list-item-checkbox', (ev) => {
        const $selected = $(ev.currentTarget);
        const $parentFacetSelector = $selected.parents('.facet-selector');
        const $allCheckboxes = $selected.parents('.facet-selector-body').find('.facet-list-item-checkbox');
        const $selectionLabel = $selected.parents('.facet-selector-body').prev().find('.selection-label');
        const $selectedText = $selected.next().find('.facet-list-item-label-text');
        $selectionLabel.html($selectedText.text());

        // Allow only one selection for now
        $allCheckboxes.not($selected).prop('checked', false);

        // Fermer le menu déroulant après la sélection
        $parentFacetSelector.removeClass('is-active');
        $('.facet-selector-toggle', $parentFacetSelector).attr('aria-expanded', 'false');
        // Annoncer la sélection à l'utilisateur
        ariaRegion.textContent = `${$selectedText.text()} ${translations[siteLanguage].selected}`;

        if (!$allCheckboxes.is(':checked')) {
            $selectionLabel.html($selectionLabel.attr('data-selection'));
        }
    });

    $('body').on('click', '.header-search-toggle', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        // hide profile menu
        const $profileMenu = $('.context-menu-profile.is-active');
        $profileMenu.removeClass('is-active').find('.js-context-menu-toggle').attr('aria-expanded', 'false');

        if ($headerSearch.hasClass('is-active')) {
            $headerSearch.removeClass('is-active');
            $headerSearchToggle.attr('aria-expanded', 'false');
        } else {
            $headerSearch.addClass('is-active');
            $headerSearchToggle.attr('aria-expanded', 'true');
            $('#autocomplete-0-input').focus();
        }
    });
}
